import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=da798d18&scoped=true&"
import script from "./Gallery.vue?vue&type=script&lang=js&"
export * from "./Gallery.vue?vue&type=script&lang=js&"
import style1 from "./Gallery.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da798d18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCarousel,VCarouselItem,VContainer,VDialog,VImg})
